(function ($) {
	$('.people-search form').on('submit', function(e){
		e.preventDefault();
		search_people();
		update_people_group_links();
		$('.people-search form').addClass('search-active');
		$('html,body').animate({ scrollTop: $("#people-search-result").offset().top  - 100}, 'slow');
	});
	$('.people-search .btn-clear').on('click', function(e){
		e.preventDefault();
		$('.people-keyword').val('');
		$('.people-search form').removeClass('search-active');
		search_people();
		update_people_group_links();
	});

	function search_people(){
		var data = {
			'action': 'search_people',
			'security': js_params.ajax_nonce,
			'keyword': $(".people-keyword").val(),
			'page' : js_params.current_page
		};

		$.ajax({
			url : js_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$(".loop-wrapper-outer").addClass('loading');
			},
			success : function( data ){
				if( data ) {
					$(".people-list-wrapper").html(data);
				}
				$(".loop-wrapper-outer").removeClass('loading');
			}
		});
	}

	function update_people_group_links(){
		var data = {
			'action': 'update_people_group_links',
			'security': js_params.ajax_nonce,
			'keyword': $(".people-keyword").val()
		};

		$.ajax({
			url : js_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
			},
			success : function( data ){
				if( data ) {
					$(".prople-group-links-wrapper").html(data);
				}
			}
		});
	}
})(jQuery);
